import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { Layout, Publications } from '@components';

const StyledMainContainer = styled.main`
  .inner {
    width: 100%;
    max-width: 900px;
    margin: 0 auto;
  }

  header {
    text-align: center;
  }

  .research-title {
    margin: 0;
    color: var(--white);
    font-family: Georgia, 'Iowan Old Style', 'Times New Roman', serif;
    font-size: clamp(44px, 8vw, 72px);
    font-weight: 600;
    line-height: 1.1;
  }

  .research-subtitle {
    max-width: 560px;
    margin: 20px auto 0;
    color: var(--light-slate);
    font-size: var(--fz-xl);
    line-height: 1.5;
  }
`;

const ResearchPage = ({ location }) => (
  <Layout location={location}>
    <Helmet title="Research" />

    <StyledMainContainer>
      <div className="inner">
        <header>
          <h1 className="research-title">Research</h1>
          <p className="research-subtitle">
            I study interesting questions and make predictions for what comes next.
          </p>
        </header>

        <Publications />
      </div>
    </StyledMainContainer>
  </Layout>
);

ResearchPage.propTypes = {
  location: PropTypes.object.isRequired,
};

export default ResearchPage;
